import * as React from "react";
import {YesNo} from "../../../admin/customFields/BooleanDisplay";

interface IProps {
	value?: boolean;
}

export const BooleanPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{props.value == true ? YesNo.YES : props.value == false ? YesNo.NO : "-"}</span>
	);
};